export const infoBlocksData = [
  {
    imageUrl:
      "https://res.cloudinary.com/vinomofo/image/upload/e_bgremoval/v1744688418/vinomofo-bottle-images/the-daily-drop.png",
    heading: "THE DAILY DROP",
    description:
      "It's straightforward. We drop a new deal every day. They stick around for three days, so don't forget to check back.",
  },
  {
    imageUrl:
      "https://res.cloudinary.com/vinomofo/image/upload/e_bgremoval/v1744688419/vinomofo-bottle-images/the-event.png",
    heading: "THE EVENT",
    description:
      "Once a month, we unlock the Whiskymōfo store for just one day —50+ killer deals, waiting for you. This is your shot to grab some serious deals.",
  },
  {
    imageUrl:
      "https://res.cloudinary.com/vinomofo/image/upload/e_bgremoval/v1744688418/vinomofo-bottle-images/the-deals.png",
    heading: "THE DEALS",
    description:
      "We get the deals because we buy in volume and pay our supplier faster than any other retailer.",
  },
]; 